// import components
import { styled, Box } from '@mui/material';

export const StyledFormContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  padding: theme.spacing(2, 0)
}));

export const StyledIsSingleDayCheckbox = styled(Box)(({ theme }) => ({
  minWidth: theme.spacing(30),

  '& label': {
    width: 'max-content'
  }
}));

export const StyledControlledDatePickerContainer = styled(Box)(({ theme }) => ({
  minWidth: theme.spacing(45)
}));
